import { render, staticRenderFns } from "./PaidPlan.vue?vue&type=template&id=d7c48cb0&"
import script from "./PaidPlan.vue?vue&type=script&lang=js&"
export * from "./PaidPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports